import React, {useState, useEffect} from 'react';
import Icon1 from "../../assets/images/icon-1.png"
import Icon2 from "../../assets/images/icon-2.png"
import Loader from '../Commons/Loader';
import axiosInstance from "../../services/api";
function Dashboard() {
  const [dashboardData, setDashboardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchData = async () => {
      try {
          const response = await axiosInstance.get('hotel/all-hotels.json'); // Make a GET request
          setDashboardData(response.data.data || []); // Set the entire array of users
      } catch (error) {
          console.error('Error fetching data:', error);
      }finally {
        setLoading(false);
      }
  };

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    
}, [dashboardData]); // Run when `userListingData` changes

    return (
      <>
      {loading && <Loader />} 

          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Overview</h1>
                </div>{/* /.col */}
              </div>{/* /.row */}
            </div>{/* /.container-fluid */}
          </div>
          <section className="content dashboard-content">
            <div className="container-fluid border-top pt-4">
              {/* Small boxes (Stat box) */}
              <div className='dashboard-wrap'>
                <div className="row">
                {dashboardData.length > 0 && dashboardData.map((item, index) => (
                  <div className="col-lg-6 col-12 dashboard-main-blk" key={index}>
                    {/* small box */}
                    <div className="small-box bg-info bashboard-1">
                      <div className="inner">
                        <h3>{item.hotelName}</h3>
                        <div className='dashboard-inner-blk'>
                            <div className='dashboard-blk  d-flex border'>
                                <img src={Icon1} alt="" />
                                <div className='dashboard-blk-content'>
                                    <p>Total Number of Rooms</p>
                                    <h2>{item.zmpRoomCount}</h2>
                                </div>
                            </div>
                            <div className='dashboard-blk  d-flex border'>
                                <img src={Icon2} alt="" />
                                <div className='dashboard-blk-content'>
                                    <p>Total Number of TVs</p>
                                    <h2>{item.zmpStbCount}</h2>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                  {/* ./col */}
                  
                  {/* ./col */}
                </div>
              </div>
              {/* /.row (main row) */}
            </div>{/* /.container-fluid */}
          </section>

      

      </>
    );
  }
  
  export default Dashboard;